<div class="layout-wrapper">
    <div class="layout-container d-flex">
        <SidebarComponent/>
        <div class="layout-content d-flex flex-column">
            <HeaderComponent />
            <router-view></router-view>
        </div>
    </div>
    <div class="layout-overlay layout-menu-toggle">
    </div>
</div>
